// extracted by mini-css-extract-plugin
export var border = "MenuList-module--border--eb29c";
export var container = "MenuList-module--container--2eb0a";
export var menuList = "MenuList-module--menuList--75c16";
export var notSubMenu = "MenuList-module--notSubMenu--ccd37";
export var showAllButton = "MenuList-module--showAllButton--c3a09";
export var subMenuList = "MenuList-module--subMenuList--2844d";